<template>
  <div class="page-sidebar">
    <section v-if="orderedProfiles.length">
      <h3>{{sections.profiles}}</h3>
      <profile-cell
        v-for="profile in orderedProfiles"
        :key="profile.id"
        :profile="profile"
        class="mb-base"/>
    </section>
    <section v-if="tags.length">
      <h3>{{sections.tags}}</h3>
      <post-cell v-for="tagPost in tagPosts" :key="tagPost.id" :post="tagPost" />
    </section>
  </div>
</template>

<script>
import { db } from '../../../lib/firebase'
import { isCurrentResidency, residencyStartMs } from '../../../lib/residency'
import ProfileCell from '../ProfileCell'
import PostCell from '../PostCell'

export default {
  name: 'ResidencySidebar',
  components: { PostCell, ProfileCell },
  props: {
    post: { type: Object, default: () => ({}) },
    sections: {
      type: Object,
      default: () => ({ profiles: 'Current Residents and Fellows', tags: 'Similar Posts' })
    }
  },

  data: () => ({
    profiles: [],
    tagPosts: [],
    unsubscribe: null
  }),

  computed: {
    orderedProfiles () {
      // Right column: current only — never duplicated in the main Residents list
      return [...this.profiles]
        .filter(profile => isCurrentResidency(profile))
        .sort((a, b) => residencyStartMs(b) - residencyStartMs(a))
    },
    tags () {
      return (this.post || {}).tags || []
    }
  },

  created () {
    this.subscribeResidents()
    this.getTagPosts()
  },

  watch: {
    post () {
      this.getTagPosts()
    }
  },

  beforeDestroy () {
    if (typeof this.unsubscribe === 'function') {
      this.unsubscribe()
    }
  },

  methods: {
    subscribeResidents () {
      this.profiles = []
      this.unsubscribe = db.collection('profiles')
        .where('abaPosition', '==', 'resident')
        .onSnapshot(
          querySnapshot => {
            querySnapshot.docChanges().forEach(docChange => {
              const doc = docChange.doc
              switch (docChange.type) {
                case 'added':
                case 'modified': {
                  const profile = { ...doc.data(), id: doc.id }
                  const index = this.profiles.findIndex(p => p.id === doc.id)
                  if (index === -1) this.profiles.push(profile)
                  else this.$set(this.profiles, index, profile)
                  break
                }
                case 'removed':
                  this.profiles = this.profiles.filter(p => p.id !== doc.id)
              }
            })
          },
          error => {
            console.error('SUBSCRIBE CURRENT RESIDENTS ERROR:', error)
          }
        )
    },

    getTagPosts () {
      const tagIds = (this.post || {}).tagIds || []
      if (!tagIds.length) {
        this.tagPosts = []
        return
      }
      const get = (collectionName) => {
        return db.collection(collectionName)
          .where('status', '==', 'public')
          .where('tagIds', 'array-contains-any', tagIds)
          .get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              this.tagPosts.push({ ...doc.data(), id: doc.id })
            })
          })
      }
      this.tagPosts = []
      return Promise.all([get('posts'), get('pages')])
    }
  }
}
</script>

<!--suppress CssInvalidAtRule -->
<style lang="scss">
  .page-sidebar {
    h3 {
      @apply mb-sm text-aba-blue;
    }
  }
</style>
